/**
 * @generated SignedSource<<b0323b6413339b13cd3eeca1695c3b16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
export type MembershipPlanSelectBodyQuery$variables = {
  getAllPlans: boolean;
  hideDrafts: boolean;
  hideNonPublic: boolean;
  organizationId: string;
  productId: string;
};
export type MembershipPlanSelectBodyQuery$data = {
  readonly organization: {
    readonly id?: string;
    readonly membershipPlans?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly cover: string;
          readonly id: string;
          readonly name: string;
          readonly status: ProductStatus;
          readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanDetailsCardFragment" | "MembershipPlanRegistrationFragment" | "RegistrationMembershipPlanDetailsFragment" | "usePermissionsFragment">;
        };
      }>;
    };
    readonly viewerMembershipPlan?: {
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanDetailsCard_OrganizationFragment">;
  } | null;
  readonly product: {
    readonly id?: string;
    readonly includedInBenefits?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly membershipPlan: {
            readonly cover: string;
            readonly id: string;
            readonly name: string;
            readonly status: ProductStatus;
            readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanDetailsCardFragment" | "MembershipPlanRegistrationFragment" | "RegistrationMembershipPlanDetailsFragment">;
          };
          readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
        };
      }>;
    } | null;
  } | null;
};
export type MembershipPlanSelectBodyQuery = {
  response: MembershipPlanSelectBodyQuery$data;
  variables: MembershipPlanSelectBodyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "getAllPlans"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hideDrafts"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hideNonPublic"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "hideDrafts",
  "variableName": "hideDrafts"
},
v8 = {
  "kind": "Variable",
  "name": "hideNonPublic",
  "variableName": "hideNonPublic"
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "args": (v9/*: any*/),
  "kind": "FragmentSpread",
  "name": "MembershipPlanDetailsCardFragment"
},
v14 = {
  "args": (v9/*: any*/),
  "kind": "FragmentSpread",
  "name": "RegistrationMembershipPlanDetailsFragment"
},
v15 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "MembershipPlanRegistrationFragment"
},
v16 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "usePermissionsFragment"
},
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v18 = [
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "membership_plan"
  }
],
v19 = [
  (v6/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "viewerMembershipPlan",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v24 = [
  (v23/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  (v23/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v37 = [
  (v36/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v39 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v36/*: any*/),
  (v38/*: any*/)
],
v40 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v36/*: any*/),
  (v38/*: any*/)
],
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v36/*: any*/),
        (v38/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v40/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v40/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v40/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v36/*: any*/),
        (v38/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v40/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v40/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v42 = [
  (v25/*: any*/)
],
v43 = [
  (v6/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": "memberships",
    "args": (v24/*: any*/),
    "concreteType": "MembershipBenefitNodeConnection",
    "kind": "LinkedField",
    "name": "membershipBenefits",
    "plural": false,
    "selections": [
      (v25/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipBenefitNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MembershipBenefit",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v29/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "memberships",
    "args": (v24/*: any*/),
    "filters": [
      "hideDrafts",
      "hideNonPublic"
    ],
    "handle": "connection",
    "key": "ProductCountChip_memberships",
    "kind": "LinkedHandle",
    "name": "membershipBenefits"
  },
  {
    "alias": null,
    "args": (v31/*: any*/),
    "concreteType": "ProductNodeConnection",
    "kind": "LinkedField",
    "name": "childProducts",
    "plural": false,
    "selections": [
      (v25/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v28/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v29/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/)
    ],
    "storageKey": "childProducts(first:3)"
  },
  {
    "alias": null,
    "args": (v31/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "ProductBadgeStack_childProducts",
    "kind": "LinkedHandle",
    "name": "childProducts"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Pricing",
    "kind": "LinkedField",
    "name": "pricing",
    "plural": false,
    "selections": [
      (v32/*: any*/),
      (v33/*: any*/),
      (v26/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "richEditorCheckoutDescription",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Checkout",
    "kind": "LinkedField",
    "name": "myCheckout",
    "plural": false,
    "selections": (v19/*: any*/),
    "storageKey": null
  },
  (v34/*: any*/),
  {
    "alias": null,
    "args": (v9/*: any*/),
    "concreteType": "MembershipBenefitNodeConnection",
    "kind": "LinkedField",
    "name": "membershipBenefits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipBenefitNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MembershipBenefit",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v35/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endsAt",
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v22/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAutoJoined",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "typeTag",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "RegistrationPricing",
    "kind": "LinkedField",
    "name": "registrationPricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "basePrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Pricing",
        "kind": "LinkedField",
        "name": "pricing",
        "plural": false,
        "selections": [
          (v33/*: any*/),
          (v26/*: any*/),
          (v32/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "registrationType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "registrationAvailability",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "landingPageUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "waitlistUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "waitlistCtaLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductApplication",
    "kind": "LinkedField",
    "name": "viewerApplication",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "QuestionNodeConnection",
    "kind": "LinkedField",
    "name": "applicationQuestions",
    "plural": false,
    "selections": (v42/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QuestionNodeConnection",
        "kind": "LinkedField",
        "name": "questions",
        "plural": false,
        "selections": (v42/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "viewerMembershipPlan",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChangeMembershipPlan",
            "kind": "LinkedField",
            "name": "viewerCanChangeMembershipPlan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "viewerActiveMembershipPlan",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "LandingPage",
    "kind": "LinkedField",
    "name": "landingPage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mode",
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MembershipPlanSelectBodyQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "membershipPlan",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "organization",
        "args": (v17/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "condition": "getAllPlans",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "membershipPlans",
                    "args": (v18/*: any*/),
                    "concreteType": "ProductNodeConnection",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              (v20/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MembershipPlanDetailsCard_OrganizationFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MembershipPlanSelectBodyQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "membershipPlan",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "organization",
        "args": (v17/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v20/*: any*/),
              {
                "condition": "getAllPlans",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "membershipPlans",
                    "args": (v18/*: any*/),
                    "concreteType": "ProductNodeConnection",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b2f60b0cb0ff8d6fdc872a381616417",
    "id": null,
    "metadata": {},
    "name": "MembershipPlanSelectBodyQuery",
    "operationKind": "query",
    "text": "query MembershipPlanSelectBodyQuery(\n  $productId: ID!\n  $organizationId: ID!\n  $hideDrafts: Boolean!\n  $hideNonPublic: Boolean!\n  $getAllPlans: Boolean!\n) {\n  product: node(id: $productId) {\n    __typename\n    ... on Product {\n      id\n      includedInBenefits(hideDrafts: $hideDrafts, hideNonPublic: $hideNonPublic) {\n        edges {\n          node {\n            id\n            membershipPlan {\n              id\n              name\n              cover\n              status\n              ...MembershipPlanDetailsCardFragment_2caBR1\n              ...RegistrationMembershipPlanDetailsFragment_2caBR1\n              ...MembershipPlanRegistrationFragment\n            }\n            ...usePermissionsFragment\n          }\n        }\n      }\n    }\n    id\n  }\n  organization: node(id: $organizationId) {\n    __typename\n    ... on Organization {\n      id\n      membershipPlans: products(type: \"membership_plan\", hideDrafts: $hideDrafts, hideNonPublic: $hideNonPublic) @include(if: $getAllPlans) {\n        edges {\n          node {\n            id\n            name\n            cover\n            status\n            ...MembershipPlanDetailsCardFragment_2caBR1\n            ...RegistrationMembershipPlanDetailsFragment_2caBR1\n            ...MembershipPlanRegistrationFragment\n            ...usePermissionsFragment\n          }\n        }\n      }\n      viewerMembershipPlan {\n        id\n      }\n      ...MembershipPlanDetailsCard_OrganizationFragment\n    }\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment MembershipPlanDetailsCardFragment_2caBR1 on Product {\n  id\n  slug\n  cover\n  name\n  description\n  ...ProductBadgeStackFragment_membership_2caBR1\n  pricing {\n    amountCents\n    frequency\n    kind\n    ...pricingUtils_usePricingDisplayValue\n    id\n  }\n}\n\nfragment MembershipPlanDetailsCard_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n  }\n}\n\nfragment MembershipPlanExperienceDetailsFragment on Product {\n  id\n  name\n  startsAt\n  endsAt\n  type\n  slug\n  cover\n  isAutoJoined\n  ...ProductTypeTagFragment\n}\n\nfragment MembershipPlanIncludedProductsFragment_2caBR1 on Product {\n  id\n  membershipBenefits(hideDrafts: $hideDrafts, hideNonPublic: $hideNonPublic) {\n    edges {\n      node {\n        id\n        product {\n          ...MembershipPlanExperienceDetailsFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment MembershipPlanRegistrationFragment on Product {\n  id\n  myCheckout {\n    id\n  }\n  registrationPricing {\n    basePrice\n    currency\n    pricing {\n      frequency\n      ...pricingUtils_usePricingDisplayValue\n      id\n    }\n  }\n  ...ProductRegistrationSectionFragment\n  ...ProductOnboardingInfoSection_Product\n}\n\nfragment MembershipPlanSelectButton_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n    viewerCanChangeMembershipPlan {\n      value\n      message\n    }\n  }\n}\n\nfragment MembershipPlanSelectSection_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n  }\n  ...MembershipPlanSelectButton_OrganizationFragment\n}\n\nfragment ProductBadgeStackFragment on Product {\n  childProducts(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        badge {\n          ...BadgeFragment\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProductBadgeStackFragment_membership_2caBR1 on Product {\n  memberships: membershipBenefits(first: 3, hideDrafts: $hideDrafts, hideNonPublic: $hideNonPublic) {\n    totalCount\n    edges {\n      node {\n        id\n        product {\n          id\n          badge {\n            ...BadgeFragment\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ProductBadgeStackFragment\n}\n\nfragment ProductOnboardingInfoSection_Product on Product {\n  name\n  cover\n  startsAt\n  type\n  richEditorCheckoutDescription\n  landingPageUrl\n  landingPage {\n    mode\n    id\n  }\n}\n\nfragment ProductRegistrationSectionFragment on Product {\n  id\n  status\n  registrationType\n  registrationAvailability\n  landingPageUrl\n  slug\n  type\n  waitlistUrl\n  waitlistCtaLabel\n  viewerApplication {\n    id\n    status\n  }\n  applicationQuestions {\n    totalCount\n  }\n  organization {\n    questions {\n      totalCount\n    }\n    viewerMembershipPlan {\n      id\n    }\n    viewerActiveMembershipPlan {\n      id\n    }\n    ...MembershipPlanSelectButton_OrganizationFragment\n    ...MembershipPlanSelectSection_OrganizationFragment\n    id\n  }\n  registrationPricing {\n    basePrice\n  }\n  ...usePermissionsFragment\n}\n\nfragment ProductTypeTagFragment on Product {\n  typeTag {\n    label\n    color\n    id\n  }\n}\n\nfragment RegistrationExperienceDetailsFormFragment on Product {\n  id\n  type\n  cover\n  richEditorCheckoutDescription\n}\n\nfragment RegistrationMembershipPlanDetailsFragment_2caBR1 on Product {\n  id\n  cover\n  richEditorCheckoutDescription\n  myCheckout {\n    id\n  }\n  ...RegistrationExperienceDetailsFormFragment\n  ...MembershipPlanIncludedProductsFragment_2caBR1\n  ...usePermissionsFragment\n}\n\nfragment pricingUtils_usePricingDisplayValue on Pricing {\n  frequency\n  kind\n  amountCents\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "39441803cf6e3e2b25dd415026e0f97a";

export default node;
